import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jobsEndpoint } from '../constants';

const JobApplicants = () => {
  const { jobId } = useParams();
  const [applicants, setApplicants] = useState([]);
  const [jobTitle, setJobTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${jobsEndpoint}${jobId}/applicants/`, {
          headers: {
            'Authorization': `Token ${token}`,
          }
        });
        setApplicants(response.data.applicants);
        setJobTitle(response.data.job_title);
      } catch (err) {
        setError('Failed to load applicants.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchApplicants();
    }
  }, [jobId, token]);

  const handleCreateOffer = (applicantId) => {
    navigate(`/offer/create/${applicantId}`);
  };

  if (loading) {
    return <div className="lg:p-8"><p>Loading...</p></div>;
  }

  if (error) {
    return <div className="lg:p-8"><p className="text-red-500">{error}</p></div>;
  }

  return (
    <div className="lg:p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">Applicants for {jobTitle}</h1>
      </div>
      <div className="bg-white rounded-xl border border-gray-200">
        <div className="pt-3 px-5">
          <h3 className="text-sm font-semibold text-gray-900">All Applicants</h3>
        </div>
        <div className="px-5 py-4 border-b border-gray-200">
          <div className="flex gap-4 items-center flex-wrap">
            {/* Add search and filter controls here if needed */}
          </div>
        </div>
        <div>
          <div className="px-5 py-3 grid grid-cols-3 border-b border-gray-200">
            <h5 className="text-gray-500 font-semibold">Candidate</h5>
            <h5 className="text-gray-500 font-semibold">Status</h5>
            <h5 className="text-gray-500 font-semibold text-right">Actions</h5>
          </div>
          {applicants.length === 0 ? (
            <div className="p-8 text-center">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No applicants yet</h3>
            </div>
          ) : (
            applicants.map((applicant) => (
              <div key={applicant.id} className="grid grid-cols-3 items-center p-4 border-b border-gray-200 hover:bg-gray-50">
                <div>
                  <p className="font-medium text-sm text-gray-900">
                    {applicant.user.first_name} {applicant.user.last_name}
                  </p>
                  <p className="text-xs text-gray-500">{applicant.user.email}</p>
                </div>
                <div>
                  <span className="text-xs bg-gray-100 text-gray-700 border border-gray-300 py-1 px-2 rounded-md capitalize">
                    {applicant.status}
                  </span>
                </div>
                <div className="text-right">
                  <button
                    onClick={() => handleCreateOffer(applicant.id)}
                    className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700"
                  >
                    Create Offer
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default JobApplicants;
